import React, { useEffect, useState } from "react";

import BlogPostForm from "./components/BlogPostForm";

import { backendGet, backendPut } from "@accredo/fe-shared/services/dataService.js";

import { CircularProgress, Box } from "@mui/material";

import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

export default function BlogPostEditPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const { blog_post_id: blogPostId } = useParams();

  const [isSaving, setIsSaving] = useState(false);
  const [loadingPost, setLoadingPost] = useState(true);

  const [blogPost, setBlogPost] = useState(null);

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const blogPostDisplayName = blogPost
    ? `${blogPost.overline ? `${blogPost.overline}: ` : ""}${blogPost.headline}` ||
      `Post #${blogPostId}`
    : `Post #${blogPostId}`;

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "News-Verwaltung", path: "/admin/blog" },
      {
        name: blogPostDisplayName,
        path: `/admin/blog/${blogPostId}`,
      },
      {
        name: "Bearbeiten",
        path: `/admin/blog/${blogPostId}/edit`,
      },
    ]);
  }, [blogPostDisplayName]);

  useEffect(() => {
    const loadPost = async () => {
      try {
        const res = await backendGet(`data/blog-posts/${blogPostId}`);

        setBlogPost(res.data);
      } catch (err) {
        setError("Fehler beim Laden");
      } finally {
        setLoadingPost(false);
      }
    };

    loadPost();
  }, [blogPostId]);

  const handleUpdate = async (payload) => {
    setError(null);
    setSuccess(null);

    try {
      await backendPut(`data/blog-posts/${blogPostId}`, {
        toSend: payload,
        label: "News-Beitrag aktualisieren",
        enqueueSnackbar,
        setIsLoading: setIsSaving,
      });

      setSuccess("News-Beitrag erfolgreich aktualisiert");

      navigate(`/admin/blog/${blogPostId}`);
    } catch (err) {
      setError(err?.response?.data?.message || "Fehler beim Aktualisieren");
    } finally {
      setIsSaving(false);
    }
  };

  if (loadingPost) {
    return (
      <Box mt={8} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 600, margin: "auto" }}>
      <BlogPostForm
        title="Inhalt bearbeiten"
        submitLabel="Aktualisieren"
        initialValues={blogPost}
        onSubmit={handleUpdate}
        loading={isSaving}
        success={success}
        error={error}
      />
    </Box>
  );
}
